import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef} from "@angular/material/dialog";
import {MatButtonModule} from "@angular/material/button";
import {MatSelectModule} from "@angular/material/select";
import { NoteDescriptor, PostVisitCategories } from '@allaihealth/notes';
import { FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';

/** New Voice Macro Dialog */
@Component({
    selector: 'voice-macro-new-dialog',
    imports: [
        MatDialogModule,
        MatButtonModule,
				MatSelectModule,
				MatInputModule,
				FormsModule
    ],
    templateUrl: './voice-macro-dialog.component.html',
    styleUrl: './voice-macro-dialog.component.scss'
})
export class VoiceMacroDialog implements OnInit {

	sections:NoteDescriptor[] = PostVisitCategories;

	constructor(private dialogRef:MatDialogRef<boolean, VoiceMacroDialog>,
	            @Inject(MAT_DIALOG_DATA) public data:VoiceMacroData) {
	}

	ngOnInit():void {
		this.dialogRef.updateSize('600px','500px');
	}
}

/** Data to pass to the dialog to open it */
export interface VoiceMacroData {
	/** Optional title for the dialog */
	section: string;
	phrase: string;
	substitution: string;
}
